import React from "react";

const PageHero = ({ eyebrow, title, gradient, subtitle, dark = false }) => {
  return (
    <section
      className={`relative pt-36 md:pt-44 pb-16 md:pb-20 overflow-hidden ${
        dark ? "bg-neutral-950 text-white" : "bg-white"
      }`}
    >
      <div className="pointer-events-none absolute inset-0 -z-0">
        {dark ? (
          <>
            <div className="absolute top-[-10%] left-[50%] -translate-x-1/2 w-[1100px] h-[1100px] rounded-full bg-[radial-gradient(circle,rgba(236,72,153,0.18),rgba(249,115,22,0.12)_30%,rgba(168,85,247,0.08)_50%,transparent_70%)]" />
          </>
        ) : (
          <>
            <div className="absolute top-[-10%] left-[50%] -translate-x-1/2 w-[1100px] h-[1100px] rounded-full bg-[radial-gradient(circle_at_center,rgba(255,180,160,0.45),rgba(255,200,180,0.2)_35%,rgba(255,255,255,0)_65%)]" />
          </>
        )}
      </div>

      <div className="max-w-[1300px] mx-auto px-6 md:px-10 relative">
        {eyebrow && (
          <span
            className={`inline-flex items-center gap-2 px-4 py-2 rounded-full border text-xs uppercase tracking-[0.2em] font-semibold ${
              dark
                ? "bg-white/5 border-white/10 text-neutral-300"
                : "bg-white border-black/10 text-neutral-700"
            }`}
          >
            {eyebrow}
          </span>
        )}
        <h1
          className={`font-display font-extrabold text-5xl md:text-7xl lg:text-[110px] tracking-[-0.04em] leading-[0.95] mt-6 ${
            dark ? "text-white" : "text-neutral-950"
          }`}
        >
          {title}{" "}
          {gradient && (
            <span className="bg-gradient-to-r from-pink-500 via-orange-500 to-purple-500 bg-clip-text text-transparent">
              {gradient}
            </span>
          )}
        </h1>
        {subtitle && (
          <p
            className={`mt-6 max-w-3xl text-lg md:text-xl leading-relaxed ${
              dark ? "text-neutral-300" : "text-neutral-600"
            }`}
          >
            {subtitle}
          </p>
        )}
      </div>
    </section>
  );
};

export default PageHero;
